import { useCallback, useState } from 'react';

import { isEmpty, isEqual } from 'lodash';
import type { Descendant } from 'slate';

const getNodes = (nodes: Descendant[]) => {
  if (isEmpty(nodes)) {
    return [
      {
        type: 'paragraph',
        children: [
          {
            text: '',
          },
        ],
      },
    ] as unknown as Descendant[];
  }

  return nodes as Descendant[];
};

type UseEditorValue = (
  nodes: Descendant[],
  onNodesChange?: (nodes: Descendant[]) => void,
) => {
  editorValue: Descendant[];
  onChange: (nodes: Descendant[]) => void;
};

export const useEditorValue: UseEditorValue = (nodes, onNodesChange) => {
  const [editorValue, setEditorValue] = useState(() => getNodes(nodes));

  const onChange = useCallback(
    (newValue: Descendant[]) => {
      setEditorValue(newValue);

      if (onNodesChange && !isEqual(editorValue, newValue)) {
        onNodesChange(newValue);
      }
    },
    [
      onNodesChange,
      editorValue,
    ],
  );

  return {
    editorValue,
    onChange,
  };
};
